import React from "react";
import { useState, useEffect } from "react";
import ListOfficalStores from "../../../../../../assets/css/components/admin/marketplace-to-marketplace/products/ListOfficalStores";
import { Text } from "../../../../../../assets/css/components/admin/marketplace-to-marketplace/modals/ModalSelectStoreAndSection";
import Card from "react-bootstrap/Card";

export default function ViewsBeforeToSend({
  isLoad,
  setIsLoad,
  paramsToSend,
  listinType,
  officialStoreName,
  setOfficialStoreName,
  stores,
}) {
  const [idSelected, setIdSelected] = useState([]);

  useEffect(() => {
    if (officialStoreName) {
      setIdSelected(officialStoreName);
    }
  }, [officialStoreName]);

  const selectStore = (merchantName) => {
    console.log("--ID--", merchantName);
    // hacemos la copia del array
    let copyArrayStore = [...officialStoreName];
    // ahora validamos si el id seleccionado existe ya en la data
    const existsValue = copyArrayStore.find((v) => v === merchantName);
    console.log("el valor", copyArrayStore);
    if (existsValue === "undefined" || !existsValue) {
      console.log("ok undefined");
      copyArrayStore.push(merchantName);
      setIdSelected([...idSelected, merchantName]);
      setOfficialStoreName(copyArrayStore);
    } else {
      console.log("deberia borrar");
      copyArrayStore = copyArrayStore.filter((v) => v !== merchantName);
      setIdSelected(copyArrayStore);
      setOfficialStoreName(copyArrayStore);
    }
  };
  return (
    <div style={{ width: "100%", height: "auto" }}>
      <ListOfficalStores.ContListProd>
        {stores.length <= 0 && (
          <Card>
            <Card.Body>No se han encontrado tiendas oficiales...</Card.Body>
          </Card>
        )}
        <ListOfficalStores.ListProduts>
          {stores &&
            stores.length > 0 &&
            stores.map((v) => (
              <ListOfficalStores.ItemsListProduts
                onClick={() => selectStore(v.name)}
                key={v.id}
                active={idSelected.includes(v.name)}
              >
                {v.name}
              </ListOfficalStores.ItemsListProduts>
            ))}
        </ListOfficalStores.ListProduts>
      </ListOfficalStores.ContListProd>
    </div>
  );
}
